import { useParams } from 'react-router-dom';

export default function UserPosts() {
  const params = useParams();
  const { username } = params;

  return (
    <div className="flex min-h-screen flex-col items-center">
      <div className="z-10 max-w-5xl w-full items-center justify-between font-mono text-sm lg:flex">
        User&#39;s Stories belonging to user with username of {username}
      </div>
    </div>
  );
}
